import { CustomEventWithDetail } from 'rune-ts';
import { StockInputValue } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';

export class ChangeSpoItemValue extends CustomEventWithDetail<{
  stock_values: StockInputValue[];
}> {}

export class DeleteSpoItems extends CustomEventWithDetail<{ delete_target_indexes: number[] }> {}
